export default __webpack_public_path__ + "static/media/pencil.9b2b6e5b.svg";